import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=05ab0c6a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=05ab0c6a&prod&lang=less"
import style1 from "./Index.vue?vue&type=style&index=1&id=05ab0c6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ab0c6a",
  null
  
)

export default component.exports